import * as angular from 'angular';
import * as _ from "lodash";
import { IBtn, IBtnArrayOptions } from './btnarray.interfaces';

interface BtnArrayScope extends angular.IScope {
    options: IBtnArrayOptions;
}

var btnArrayCtrl = ($scope: any) => {
    let vm = {
        select: (button: IBtn): void => {
            // invoke parent action
            if ($scope.vm.options.select !== null) {
                $scope.vm.options.select(button);
            }
            
            // clear all button selections
            $scope.vm.options.buttons.forEach((button: IBtn) => {
                button.selected = false;
            });
            
            // mark the correct button as selected
            button.selected = true;
        },
        scope: $scope
    };
    return vm;
};

export default angular.module('aps.controller.btnArray', [])
    .controller('btnArrayCtrl', btnArrayCtrl)
    .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/btnarray.controller.ts